import axios from "axios";
import { IVODAttachments } from "../types";

class FilesService {
  async getVODAttachments(mediaId: string): Promise<IVODAttachments> {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/vod/${mediaId}/attachments`
      );
      return response.data.data;
    } catch (err) {
      console.error("Failed to fetch VOD attachments", err);
      return { files: [], hyperlinks: [] };
    }
  }
}

export const filesService = new FilesService();
